$(document).ready(function() {
        $(".open-menu").on("click", function(event) {
            event.preventDefault(); // Prevents the default link behavior
            
            var detailsElement = $(this).parent().parent(); // Finds the parent <details> element
            
            var isOpen = detailsElement.attr("open");
            
            if (isOpen) {
                detailsElement.removeAttr("open");
                detailsElement.find("summary").attr("aria-expanded", "false");
            } else {
                detailsElement.attr("open", "");
                detailsElement.find("summary").attr("aria-expanded", "true");
            }
        });
        $(".mobile-ptoduct").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 10,
        responsiveClass: true,
        autoHeight: true,
        loop:true,
        nav: true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1,
                margin: 0
            },
            480: {
                items: 1,
                margin: 0
            },
            600: {
                items: 1.1,
                margin: 0
            }
        }
    });
  // models slider
   $(".modal-ptoduct").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 10,
        responsiveClass: true,
        autoHeight: true,
        loop:true,
        nav: true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1,
                margin: 0
            },
            767: {
                items: 1,
                margin: 0
            },
          1024: {
                items: 1,
                margin: 0
            },
            1300: {
                items: 1,
                margin: 0
            }
        }
    });
    $(".owl-carousel-home").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        loop:true,
        nav: true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2,
                margin: 20
            },
            480: {
                items: 2,
                margin: 20
            },
            600: {
                items: 2
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 4
            },
            1366: {
                items: 4
            }
        }
    });
   //about_store  
$(".owl-carous_about_store").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2,
                margin: 20
            },
            480: {
                items: 2,
                margin: 20
            },
            600: {
                items: 2
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 3,
                margin: 20
            },
            1024: {
                items: 3
            },
            1366: {
                items: 3
            }
        }
    });
 
    // first-image-as
    $(".first-image-as").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1,
                margin: 20
            },
            480: {
                items: 1,
                margin: 20
            },
            600: {
                items: 1,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 3
            },

            1366: {
                items: 3
            }
        }
    });
    // New Arrival 
    $(".owl-carousel-new-arrivles").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        loop:true,
        autoHeight: true,
        nav: true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2,
                margin: 20
            },
            480: {
                items: 2,
                margin: 20
            },
            600: {
                items: 2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 4
            },

            1366: {
                items: 4
            }
        }
    });
    // image with slider
    $(".imgewithslider").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1,
                margin: 20
            },
            480: {
                items: 1,
                margin: 20
            },
            600: {
                items: 2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 3
            },

            1366: {
                items: 3
            }
        }
    });
    $(".imgewithslider2").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1.2,
                margin: 20
            },
            480: {
                items: 1.2,
                margin: 20
            },
            600: {
                items: 2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20,
              
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 3
            },

            1366: {
                items: 3
            }
        }
    });
    // slider with image

    $(".sliderwithimage").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2.2,
                margin: 20
            },
            480: {
                items: 2.2,
                margin: 20
            },
            600: {
                items: 2.2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 4
            },

            1366: {
                items: 2
            }
        }
    });
    /// Best selling Cate
    $(".bestselling").owlCarousel({
        autoplay: false,
        rewind: true,
        /* use rewind if you don't want loop */
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2,
                margin: 20
            },
            480: {
                items: 2,
                margin: 20
            },
            600: {
                items: 2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 4
            },

            1366: {
                items: 4
            }
        }
    });
    // image and slider 2
    $(".imageslidersecond").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2.2,
                margin: 20
            },
            480: {
                items: 2.2,
                margin: 20
            },
            600: {
                items: 2.2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 2
            },
            1366: {
                items: 2
            }
        }
    });
    // slider and image 2
    $(".slidersecond").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2.2,
                margin: 20
            },
            480: {
                items: 2.2,
                margin: 20
            },
            600: {
                items: 2.2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 2
            },
            1366: {
                items: 2
            }
        }
    });
    // Our artisan list
    $(".ourartisanlist").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2.2,
                margin: 20
            },
            480: {
                items: 2.2,
                margin: 20
            },
            600: {
                items: 2.2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 6
            },

            1366: {
                items: 6
            }
        }
    });
    // Our Patron
    $(".ourpatron").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2.2,
                margin: 20
            },
            480: {
                items: 2.2,
                margin: 20
            },
            600: {
                items: 2.2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 4
            },

            1366: {
                items: 4
            }
        }
    });
    // Testimonial Section
    $(".testimonial-slider").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 2,
                margin: 20
            },
            480: {
                items: 2,
                margin: 20
            },
            600: {
                items: 1
            },

            1024: {
                items: 1
            },

            1366: {
                items: 1
            }
        }
    });
    /**/
    $(".imgewithslider22").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1.2,
                margin: 20
            },
            480: {
                items: 1.2,
                margin: 20
            },
            600: {
                items: 2.2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 3
            },

            1366: {
                items: 3
            }
        }
    });
    // Our work slider
    $(".ourwork").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        loop:true,
        nav: true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1,
                margin: 20
            },
            480: {
                items: 1,
                margin: 20
            },
            600: {
                items: 2,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 4
            },

            1366: {
                items: 4
            }
        }
    });
    // Our blogs
    $(".ourblogs").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: false,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1,
                margin: 20
            },
            480: {
                items: 1,
                margin: 20
            },
            600: {
                items: 1,
                margin: 20
            },
            767: {
                items: 3,
                margin: 20
            },
            990: {
                items: 4,
                margin: 20
            },
            1024: {
                items: 3
            },

            1366: {
                items: 3
            }
        }
    });
    var contentproduct = $('#productcon');
    var paragraphs = contentproduct.find('p');
    var visibleItems = 3;
    if (paragraphs.length > visibleItems) { //alert();
        paragraphs.slice(0, visibleItems).show();
        $('#viewMoreBtn').show();
    }
    $('#viewMoreBtn').click(function() {
        contentproduct.toggleClass('expanded');
        if (contentproduct.hasClass('expanded')) {
            $('#viewMoreBtn').text('View Less');
        } else {
            $('#viewMoreBtn').text('View More');
        }
    });
    // $(".image2").hide("main");
    // $(".forget").click(function() {
    //     $(".image1").hide("main");
    //     $(".image2").show("main");
    // });
    // $(".cls").click(function() {
    //     $(".image1").show("main");
    //     $(".image2").hide("main");
    // });
    var lastClicked = "";
    $(".setup-red").click(function() {
        if ($(this).removeAttr('open')) { //alert();
            setTimeout(() => {
                $(".setup-red").removeAttr("open");
                $(this).prop("open", true);
            }, 100);
        }
    });
  $('#p_submit').click(function(event) {
        var isValid = true;
        var Num = $('#RegisterForm-FirstName').val().trim();
        var Lastname = $('#RegisterForm-LastName').val().trim();
        var email = $('#RegisterForm-email').val().trim(); //alert(email);
        var password = $('#RegisterForm-password').val().trim(); //alert(password);
        var mobNum = $('#RegisterForm-note').val();
        data = $('#RegisterForm-password').val();
        if (!Num.length) {
            $("#lblErrorname").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorname").css("display", "none");
        }
        if (!Lastname.length) { //alert("abc");
            $("#lblErrorl").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorl").css("display", "none");
        }
        if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) { //alert("abc");
            $("#lblErrorlemail").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorlemail").css("display", "none");
        }
        if (!password.length) { //alert(password);
            $("#lblErrorpw").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorpw").css("display", "none");
        }
        if ($('input:checkbox').is(':checked')) {
            $("#lblError1").css("display", "none");
        } else {
            $(".checked_a").css("color", "red");
            isValid = false;
        }
        if (!(mobNum.length !== 10 || !/^[0-9]+$/.test(mobNum))) { //alert("mobile");
            $("#lblError").css("display", "none");
            $("#lblError111").css("display", "none");
        } else if (mobNum.length > 10 || mobNum.length < 10) {
            $("#lblError").css("display", "none");
            $("#lblError111").css("display", "block");
            isValid = false;
        } else {
            $("#lblError").css("display", "block");
            $("#lblError111").css("display", "none");
            isValid = false;

        }
        if (!isValid) {
            event.preventDefault();
        }
        return isValid;
    });

    $('#login_sub').click(function(event) {
        var isValid = true;
        var email = $('#CustomerEmail').val().trim(); //alert(email);
        var customerPassword = $('#CustomerPassword').val();
        if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) { //alert();
            $("#lblErrorlemail").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorlemail").css("display", "none");
        }
        if (customerPassword.length > 10 || customerPassword.length < 6) {
            $("#lblErrorlpw").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorlpw").css("display", "none");
        }
        if (!isValid) {
            event.preventDefault();
        }
        return isValid;
    });
    $(".bgop").hover(function() {
        $("#MainContent").addClass("Mydivadd");
    });
    $(".bgop").mouseout(function() {
        $("#MainContent").removeClass("Mydivadd");
    });
    $('.nav1').eq(0).toggleClass("open");
    $(".footer__blocks-wrapper h2").click(function() {
        //console.log("Clicked!");
        $(this).parent(".nav1").toggleClass("open");
        $(this).parent(".nav1").siblings().removeClass("open");
    });
    $('.close-btn').on('click', function() {
        var item = $(this).closest('details');
        item.removeAttr('open');
        item.find('summary').attr('aria-expanded', 'false');
        $("body").removeClass('overflow-hidden-tablet');
    });
    $('.mega-menu__content').click(function(){
      var item = $(this).closest('details');
      item.removeAttr('open');
      item.find('summary').attr('aria-expanded', 'false');
    });
    // $('body').click(function(){
    //   var navMenu = $('header-menu').children('details');
    //     if($(navMenu).hasAttr('open')){
    //       navMenu.removeAttr('open');
    //       navMenu.find('summary').attr('aria-expanded', 'false');
    //     }
    // });
    $('#contactFormSubmit').click(function(event) {
        var isValid = true;
        var Num = $('#ContactForm-name').val().trim();
       var lastNum = $('#ContactForm-last-name').val().trim();
        var email = $('#ContactForm-email').val().trim(); //alert(email);
        var mobNum = $('#ContactForm-phone').val();
        if (!Num.length) { //alert("abc");
            $("#lblErrorname").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorname").css("display", "none");
        }
      if (!lastNum.length) { //alert("abc");
            $("#lblErrorlastname").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorlastname").css("display", "none");
        }
        if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) { //alert();
            $('#emailError').text('Please enter a valid email address.');
            $("#lblErrorlemail").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorlemail").css("display", "none");
        }
        if (mobNum.length !== 10 || !/^[0-9]+$/.test(mobNum)) { //alert();
            $("#lblError111").css("display", "block");
            isValid = false;
        } else {
            $("#lblError111").css("display", "none");
        }
        if (!isValid) {
            event.preventDefault();
        }
        return isValid;
    });
    $('.addres-submit').click(function(event) {
        var isValid = true;
        var mobzip = $('#AddressZipNew').val();
        var mobNum = $('#AddressPhoneNew').val();
        if (mobzip.length < 6 || mobzip.length > 6) { //alert();
            $("#lblErrorzip").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorzip").css("display", "none");
        }
        if (mobNum.length !== 10 || !/^[0-9]+$/.test(mobNum)) { //alert();
            $("#lblErrormo").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrormo").css("display", "none");
        }
        if (!isValid) {
            event.preventDefault();
        }
        return isValid;
    });
    $('.update-submit').click(function(event) {
        var isValid = true;
        var mobzip = $('.uAddressZipNew').val();
        var mobNum = $('.UAddressPhone').val();
        if (mobzip.length < 6 || mobzip.length > 6) { //alert();
            $("#lblErrorzip").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrorzip").css("display", "none");
        }
        if (mobNum.length !== 10 || !/^[0-9]+$/.test(mobNum)) { //alert();
            $("#lblErrormo").css("display", "block");
            isValid = false;
        } else {
            $("#lblErrormo").css("display", "none");
        }
        if (!isValid) {
            event.preventDefault();
        }
        return isValid;
    });
    $('.custIn').change(function() {
      var vid = $(this).attr('v_id');
      if ($(this).hasClass('first')) {
       var addSymbolElement = $('.bought_together_container li:eq(1) .add_symbol');
        if ($(this).prop('checked')) {
          addSymbolElement.css('display', 'block');
        } else {
          addSymbolElement.css('display', 'none');
        }
      }
      $('#fbt-img li img[data-id="' + vid + '"]').closest('li').show(); 
        if ($(this).prop('checked')) {
          $('#fbt-img li img[data-id="' + vid + '"]').closest('li').show();
        } else {
          $('#fbt-img li img[data-id="' + vid + '"]').closest('li').hide();
        }
        var totallenth = $('#totalPrice').text(totalPrice);
        var totalPrice = 0;
        $('.custIn:checked').each(function() {
            tempPrice = $(this).val() * 1 / 100;
            totalPrice += parseInt(tempPrice);
          console.log(totalPrice);
        });
      console.log(tempPrice);
      if (totalPrice  == 0) {      
        $('#totalPrice').text(totalPrice);
        $("#but_it_with").addClass("add_disabled").prop('disabled', false);
      } else { 
        $('#totalPrice').text(totalPrice);        
       $("#but_it_with").removeClass("add_disabled").prop('disabled', true);
      }
    });

    const $productSlider = $("#productSlider");
   const $playPauseButton = $(".play-pause-button");
    let isPlaying = true;

    $productSlider.owlCarousel({
      items: 1, // Adjust the number of items to show in the grid
      loop: true,
      margin: 30,
       nav: true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsiveClass: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });
    $(".image--blocks").owlCarousel({
        autoplay: false,
        rewind: true,
        margin: 30,
        responsiveClass: true,
        autoHeight: true,
        nav: true,
        loop:true,
        navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
        responsive: {
            0: {
                items: 1,
                margin: 20
            },
            480: {
                items: 1,
                margin: 20
            },
            600: {
                items: 1,
                margin: 20
            },
            767: {
                items: 3,
                margin: 30
            },
            990: {
                items: 4,
                margin: 30
            },
            1024: {
                items: 4,
                margin: 30
            },

            1366: {
                items: 4,
                margin: 30
            }
        }
    });
  // $(".recently-viewed").owlCarousel({
  //       autoplay: false,
  //       rewind: true,
  //       margin: 30,
  //       responsiveClass: true,
  //       autoHeight: true,
  //        nav: true,
  //       navText: ["<img class='imgee-pv' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-prev.png?v=1613503950'>", "<img class='imgee-next' src='https://cdn.shopify.com/s/files/1/2116/1923/files/arrow-next.png?v=1613503950'>"],
  //         responsive: {
  //           0: {
  //               items:2.2
  //           },
  //           480: {
  //               items: 2.2
  //           },
  //           600: {
  //               items: 2.2
  //           },
  //           767: {
  //               items: 2.2
  //           },           
  //           1024: {
  //               items: 4
  //           },

  //           1366: {
  //               items: 4
  //           }
  //       }
  //   });
    function togglePlayPause() {
      isPlaying = !isPlaying;
      const buttonText = isPlaying ? "Pause" : "Play";
      $playPauseButton.text(buttonText);
      if (isPlaying) {
        $productSlider.trigger("play.owl.autoplay", [2000]);
        $(".play-pause-button").addClass("play-btn");
        $(".play-pause-button").removeClass("stop-btn");
      } else {
        $productSlider.trigger("stop.owl.autoplay");
        $(".play-pause-button").addClass("stop-btn");
         $(".play-pause-button").removeClass("play-btn");
      }
    }
  $playPauseButton.click(function() {
      togglePlayPause();
    });
              $("select").change(function(){
                $(this).find("option:selected").each(function(){
                  var optionValue = $(this).attr("value");
                  if(optionValue){
                    $(".box").not("." + optionValue).hide();
                    $("." + optionValue).show();
                  } else{
                    $(".box").hide();
                  }
                });
              }).change();
            });

function myFunction(x) {
    if (x) { // If media query matches 
        //alert("I am an alert box!");
        $('.chk_container.desktop_hide input').addClass('custIn');
        $('.chk_container.mobile_hide input').removeClass('custIn');
        console.log('Classes added');
    } else {
        //alert("x.matches");
        $('.chk_container.desktop_hide input').removeClass('custIn');
        $('.chk_container.mobile_hide input').addClass('custIn');
        console.log('Classes removed');
    }
}

var x = window.matchMedia("(max-width: 900px)")
myFunction(x) // Call listener function at run time
x.addListener(myFunction) // Attach listener function on state changes

$('#but_it_with').click(function() {
    $(this).html('Adding To Cart');
    $('.custIn').each(function() {
        if ($(this).is(":checked")) {
            var o = $(this).attr("v_id");
            console.log(o, 'BI01 variant id');
            var data = 'id=' + o + '&quantity=1'
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                async: false,
                cache: false,
                success: function(res) {
                    setTimeout(function() {
                        window.location.assign('/cart');
                    }, 3000);
                },
                error: function(res) {
                    console.log("res::", res.description);
                }
            });
        }

    });
});

var acc = document.getElementsByClassName("setup-red");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

$(function() {
		var Accordion = function(el, multiple) {
				this.el = el || {};
				this.multiple = multiple || false;

				var links = this.el.find('.article-title');
				links.on('click', {
						el: this.el,
						multiple: this.multiple
				}, this.dropdown)
		}

		Accordion.prototype.dropdown = function(e) {
				var $el = e.data.el;
				$this = $(this),
						$next = $this.next();

				$next.slideToggle();
				$this.parent().toggleClass('open');

				if (!e.data.multiple) {
						$el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
				};
		}
		var accordion = new Accordion($('.accordion-container'), false);
});


$(window).scroll(function(){
    if ($(window).scrollTop() >= 180) {
        $('.product__info-wrapper').addClass('sticky-column');
        
    }
    else {
        $('.product__info-wrapper').removeClass('sticky-column');
    }
});
// $(document).ready(function() {
//     $('.read').click(function() {
//         $(".open1").addClass('open');
//       $(".open2").css("display", "block")
//     });
// });
$(window).scroll(function(){ // alert();
    if ($(window).scrollTop() >= 300) {
        $('.moible-buy').addClass('sticky-column-mibile');
       $('.price-mobile').addClass('sticky-column-mibile');       
    }
    else {
        $('.moible-buy').removeClass('sticky-column-mibile');
      $('.price-mobile').removeClass('sticky-column-mibile');
    }
});

$(document).ready(function(e){
      //       checkout button click function
      $('.checkout-btn-sticky input[type="button"]').on('click',function(){
        $('.zip-input').addClass('error-focus').focus();
      });
      // // alert("PincodeChecker");
      // if ($.cookie('pincode_value') != null ){ alert("testing1");
      //   var pincode_value=$.cookie('pincode_value');
      //   $(".zip-input").val(pincode_value);
      // }
   // $(".zip-input").on("keypress", function(e) {
   //   alert("77777");
   //  });
      $(".zip-input").on("keypress", function(e) {  //alert("testing");
        var key = e.which;
        if(key == 13){
          $("#zip-check").click();
          return false;  
        }
      });
      $(".zip-input").on("keyup", function(e) {
        var key = e.which;
        $("#zip-check").click();
      });
    });

    $("#zip-check").on('click',function(){
      pincode_checker();
    });  
$(document).ready(function(){
$('#btn').click(function(){ //alert();
     var param = $('#param').val();
      var url = 'https://www.delhivery.com/track/package/'+param;
      window.location.href = url;
    });
});



function addToPlaceholder(toAdd, el) {
    el.attr('placeholder', el.attr('placeholder') + toAdd);
    return new Promise(resolve => setTimeout(resolve, 100));
}

function clearPlaceholder(el) {
    el.attr("placeholder", "");
}

// function printPhrase(phrase, el) {
//     return new Promise(resolve => {
//         clearPlaceholder(el);
//         let letters = phrase.split('');
//         letters.reduce(
//             (promise, letter, index) => promise.then(_ => {
//                 if (index === letters.length - 1) {
//                     setTimeout(resolve, 1000);
//                 }
//                 return addToPlaceholder(letter, el);
//             }),
//             Promise.resolve()
//         );
//     });
// }

async function printPhrase(phrase, el) {
    clearPlaceholder(el);
    let letters = phrase.split('');
    
    for (let i = 0; i < letters.length; i++) {
        await addToPlaceholder(letters[i], el);
    }

    return new Promise(resolve => setTimeout(resolve, 1000));
}


async function printPhrases(phrases, el) {
    while (true) {
        for (const phrase of phrases) {
            await printPhrase(phrase, el);
        }
    }
}

async function run() {
    let phrases = [
        "Search for Dresses",
        "Search for Kurtas",
        "Search for Sarees"
    ];

    await printPhrases(phrases, $('#Search-In-Modal'));
}
async function run1() {
    let phrases = [
        "Search for Dresses",
        "Search for Kurtas",
        "Search for Sarees"
    ];

    await printPhrases(phrases, $('#Search-In-Modal-1'));
}
// if (window.innerWidth < 768) {
  run1();
// } else {
  run();
// }


 $(".copy-url").click(function (e) {
  e.preventDefault();
  var s = $(this).prev(".sharing-link").attr("data-link"); //alert();

  // Create a temporary textarea to copy the text to the clipboard
  var $tempTextarea = $("<textarea>");
  $("body").append($tempTextarea);
  $tempTextarea.val(s).select();

  try {
    // Execute copy command
    document.execCommand("copy");
    console.log("Text copied to clipboard");

    // Show the "Copied" message
    var $copiedMessage = $(".share-button__message");
    var $showMsg = $(".product__info-wrapper .share-button__fallback .field");
    $copiedMessage.removeClass("hidden");
    $showMsg.css("opacity", "1");

    // Hide the message after 1 second
    setTimeout(function () {
      $copiedMessage.addClass("hidden");
      $showMsg.css("opacity", "0");
    }, 1000);
  } catch (err) {
    console.error("Unable to copy text to clipboard", err);
  } finally {
    // Clean up and remove the temporary textarea
    $tempTextarea.remove();
  }
   Swal.fire({
  position: "top-end",
  title: "URL copied to clipboard",
  showConfirmButton: false,
  timer: 1000
});
});
